// Un « < » non échappé refermerait la balise script depuis une donnée éditoriale (XSS).
export function serializeJsonLd(document: Record<string, unknown>): string {
  return JSON.stringify({ "@context": "https://schema.org", ...document }).replace(/</g, "\\u003C");
}
